import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { toggleDrawer, confirm } from '../../helpers/helpers.js'

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Locations = observer(class Locations extends React.Component {
  constructor() {
    super();
    this.deleteLocation = this.deleteLocation.bind(this);
  }

  componentWillMount() {
    const { LocationStore } = this.props.store;

    this.state = {
      drawerOpen: false,
      drawerContent: null,
      locationSid: null
    }

    LocationStore.getLocations();
  }

  handleEdit(locationSid) {
    const { LocationStore, SessionStore } = this.props.store;
    const { confirmedLocations } = this.props;

    if(confirmedLocations.indexOf(locationSid) === -1) {
      // Reset stored location data
      LocationStore.resetLocation();

      // Set this location sid
      this.props.parent.setState({
        locationSid: locationSid
      });

      // Hide the drawer button
      SessionStore.hideDrawerClose = true;

      // Open the drawer
      toggleDrawer(null, this.props.parent, 'LocationEdit');
    }
  }

  deleteLocation(location) {
    const { translation } = this.props;
    const { LocationStore } = this.props.store;

    const msg = {
      heading: `${translation.delete_confirm.heading} ${location.name}?`,
      body: translation.delete_confirm.body,
      button: translation.delete_confirm.button
    }

    confirm(msg, () => LocationStore.deleteLocation(location.sid));
  }

  renderResults() {
    const { LocationStore } = this.props.store;
    const { translation } = this.props;
    const { confirmedLocations } = this.props;

    if(LocationStore.locations.length > 0) {
      return (
        <ul className="tally">
          {LocationStore.locations.map(
            (key, i) =>
            <li
              key={i}
            >
              <h3
                onClick={() => this.handleEdit(key.sid)}
              >
                {key.name}
              </h3>

              {confirmedLocations.indexOf(key.sid) === -1 &&
                <button
                  className="btn--link"
                  onClick={() => this.handleEdit(key.sid)}
                >
                  {translation.confirm}
                </button>
              }

              {confirmedLocations.indexOf(key.sid) > -1 &&
                translation.confirmed
              }

              <span
                className={`tally__status
                  ${confirmedLocations.indexOf(key.sid) > -1 ? 'completed' : ''}
                `}
                onClick={() => this.handleEdit(key.sid)}
              >
                <span className="meta">
                  {confirmedLocations.indexOf(key.sid) > -1 ? 'completed' : ''}
                </span>
              </span>

              <button
                className="tally__delete btn--delete"
                type="button"
                onClick={() => this.deleteLocation(key)}
              >
                <icons.iconTrash />
                <span className="meta">{translation.delete}</span>
              </button>
            </li>
          )}
        </ul>
      )
    }

    return null;
  }

  render() {
    const { confirmedLocations, translation } = this.props;
    const { LocationStore } = this.props.store;

    return(
      <div className="panel">
        <div className="panel__header">
          <h3 className="panel__title">
            {translation.heading}
          </h3>
        </div>

        <div className="panel__body">
          <p className="note note--prominent">{translation.body}</p>

          {this.renderResults()}

          <div className="panel__actions actions">
            <button
              className="actions__btn actions__btn--secondary"
              onClick={this.props.prevStep}
            >
              {translation.back}
            </button>

            <button
              className="actions__btn actions__btn--primary"
              onClick={this.props.nextStep}
              disabled={confirmedLocations.length < LocationStore.locations.length}
            >
              {translation.button}
            </button>
          </div>
        </div>
      </div>
    )
  }
})

export default translate('Locations')(Locations);



// WEBPACK FOOTER //
// ./src/app/components/Checkup/Locations.js